<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5DRDyI/tc-custom/9781455605477.jpg?1700849440779" alt="This image is the cover for the book The Was an Old Lady Who Swallowed Some Bugs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Was an Old Lady Who Swallowed Some Bugs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A gross and giggle-inducing take on the classic children’s song with “sly humor and a bit of the unexpected presented with bold art” (<i>School Library Journal</i>).</b><br/>  <br/> There was an old lady who swallowed a fly . . . Young readers will love hearing about the fly and all the other creepy-crawly bugs the old lady gulps down in this fanciful feast. With a taste for slugs, the old lady enjoys a poached roach, a squirmy worm, a wiggly spider, and more during the course of the tale. And a surprise ending reveals that this isn’t just any old lady.<br/> Accompanied by Johnette Downing’s signature colorful collage illustrations, this good and gross tale pops off the page with its fun, musical language and whimsical look at the insect food chain.<br/>  <br/> “Johnette Downing has done it again . . . Another entertaining read for young ones.” —<i>Baton Rouge Advocate</i><br/>  <br/> “As an enthusiast of fractured tales and a big fan of Johnette’s songs and stories, I give Johnette’s new book a big ten thumbs up. Her funny and surprising version gives a new twist to an old favorite. It is ‘kidtastic!’” —Ann L. Davis, head of children’s services, Napa City-County Library, Napa, California </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Johnette Downing
      </h2>
      
      <p class="authorDescription body article">Johnette Downing is an award-winning and internationally recognized singer and songwriter. Her many accolades include eight Parents’ Choice Awards, four iParenting Media Awards, and five National Parenting Publication Awards. She wrote and/or illustrated <B><I>There Was an Old Lady Who Swallowed Some Bugs, Why the Crawfish Lives in the Mud, How to Dress a Po’ Boy, Why the Oyster Has the Pearl, Why the Possum Has a Large Grin, Macarooned on a Dessert Island, The Fifolet,</I></B> and other Pelican titles. Downing lives in New Orleans, Louisiana.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66af1bfc